import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "jsonParse"
})
export class JsonParsePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return value ? JSON.parse(value) : null;
  }
}
